import { map as rxjsmap } from 'rxjs';
import { ReturnStatement } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestOptions } from 'http';
import { Observable } from 'rxjs';
import { ApprovalNotices } from '../follow-ups/models/riskanalysis';
import { BaseServices } from '../kuba.services';
import { SjaForm, SjaTitleForm } from './components/sja-form';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/_services';

@Injectable()
export class SJAFormServices {
  headers: Headers;
  options: RequestOptions;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  createSjaForm(sjaFormData: SjaForm) {
    return this.http
      .post(environment.BASE_URL + '/project/sjaform/save', sjaFormData).pipe(rxjsmap(result => result));
  }

  /**
   * Get SJA Form List for the modules
   * @param featureId ID of the feature (Module) to get SJA Forms for
   * @param featureKey ID / PK in the module's table to get SJA Forms for
   */
  getSJAFormList(featureId: number, featureKey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/project/get/sjadata/${featureId}/${featureKey}`
      ).pipe(rxjsmap(result => result));
  }

  /**
   * Get SJA Form List for the "Follow Up"-Module
   * @param businessId ID of business to get SJA Forms for
   * @returns List of SJA Forms
   */
  getFollowUpSJAFormList(businessId: number) {
    return this.http
      .get(`${environment.BASE_URL}/followup/get/sjadata/${businessId}`).pipe(rxjsmap(result => result));
  }

  getSJAForm(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/get/sjadata/' + Id).pipe(rxjsmap(result => result));
  }

  /**
   * Sends approval notice mail for SJA forms in the Follow Up -module
   * @param businessId ID of business to send mail for
   * @returns Void / 204 No content (If successful)
   */
  sendSjaFormEmail(businessId: number) {
    return this.http.post<void>(
      environment.BASE_URL + '/project/sjaform/sendmail/' + businessId,
      null
    );
  }

  /**
   * Get a single signature image for an SJA form (slot: Responsible | AreaManager | Execution | Other).
   * Returns a blob to keep the main GET by id response small.
   */
  getSjaFormSignature(formId: number, slot: string): Observable<Blob> {
    return this.http.get(
      `${environment.BASE_URL}/project/sjaform/${formId}/signature/${slot}`,
      { responseType: 'blob' }
    );
  }

  deleteSJAForm(Id: number) {
    return this.http.put(
      environment.BASE_URL + '/project/delete/sjaform/' + Id,
      null
    );
  }

  exportSJAForm(sjaFormId: number, cultureInfo: string, appId: number) {
    let dynamicType = 'application/pdf';
    let myData = JSON.stringify({ data: sjaFormId });
    let crfToken = this.authenticationService.getCsrfToken();
    let url = `${environment.BASE_URL}/export-sjaform/${sjaFormId}/${BaseServices.BusinessId}/${BaseServices.ApplicationId}/${cultureInfo}`;
    return Observable.create(observer => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Logo-Id', 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba');
      xhr.setRequestHeader('X-XSRF-TOKEN', crfToken);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let contentType = dynamicType;
            let blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send(myData);
    });
  }

  addApprovalNotices(approvalNotice: ApprovalNotices[]) {
    return this.http
      .post(environment.BASE_URL + '/project/sjaform/approved', approvalNotice).pipe(rxjsmap(result => result));
  }

  getAllApproved(featureKey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/project/sjaform/approval/${BaseServices.BusinessId}/${featureKey}`
      ).pipe(rxjsmap(result => result));
  }

  getAllApprovedForKubaControl(featureKey: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/kubacontrol/sjaform/approval/${BaseServices.BusinessId}/${featureKey}`
      ).pipe(rxjsmap(result => result));
  }

  SaveSjaTitle(sjaTitleForm: SjaTitleForm) {
    return this.http
      .post(environment.BASE_URL + '/project/sjaTitle/save', sjaTitleForm).pipe(rxjsmap(result => result));
  }

  GetSJATitleList() {
    return this.http
      .get(
        `${environment.BASE_URL}/project/sjaformtitle/${BaseServices.ApplicationId}/${BaseServices.BusinessId}`
      ).pipe(rxjsmap(result => result));
  }

  DeleteSJATitle(Id: number) {
    return this.http.delete(
      `${environment.BASE_URL}/project/sjaTitle/Delete/${Id}`
    );
  }
}
